import React from 'react';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IPrintTransmitPODialogProperties } from './PrintTransmitPODialog.properties';
import PrintTransmitPOSchema from './PrintTransmitPODialog.form';
import { usePODispatch } from 'components/PurchaseOrders/PurchaseOrders.context';

const PrintTransmitPODialog = (props: IPrintTransmitPODialogProperties) => {
    const {
        open, loading, onCancel, onOk, data, supplierId, values, purchaseOrderOuputOptions, isProcessing,
        setPurchaseOrderOuputOptions, clearPurchaseOrderOuputOptions
    } = props;

    const initialValues = React.useMemo(() => (data?.inlineObject), [data]);
    const schema = React.useMemo(() => (data?.schema), [data]);
    const contextDispatch = usePODispatch();

    React.useEffect(
        () => {
            if (data && open) {
                setPurchaseOrderOuputOptions(data?.inlineObject?.TTDocout);
            } else {
                clearPurchaseOrderOuputOptions();
            }
        },
        [data, open]
    );

    return (
        <div>
            <FormViewModal
                open={open}
                loading={loading}
                title='Print / Transmit Purchase Order'
                formProps={{
                    formSchema: PrintTransmitPOSchema,
                    initialValues: {
                        ...initialValues,
                        PrintPO: initialValues && initialValues?.PrintPurchaseOrderOutput ? initialValues?.PrintPurchaseOrderOutput?.Summary : ''
                    },
                    valuesSchema: schema,
                    style: { height: '200px', minWidth: '600px' },
                    supplierId: supplierId,
                    fieldExtensions: {},
                }}
                actions={[
                    {
                        title: 'Ok',
                        disabled: isProcessing,
                        listener: () => {
                            if (onOk) {
                                onOk({
                                    ...values,
                                    PrintPurchaseOrderOutput: purchaseOrderOuputOptions
                                });
                            }
                        }
                    },
                    {
                        title: 'Cancel',
                        isDefault: true,
                        listener: () => {
                            if (onCancel) {
                                contextDispatch({ setProcessPurchaseOrderDetails: { Action: null, UserId: null, Pin: null } });
                                onCancel();
                            }
                        },
                    },
                ]}
                dialogActionsButtons={true}
                dialogActionsShadow={false}
            />
        </div>
    );
};

export default PrintTransmitPODialog;
